import { instBundle } from '@/axios.js';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { beautyProfileTitleFromIdList } from '@/util.js';
import {
	skinTypeList,
	genderList,
	eventTypeList,
	instaCateList,
	gradeList,
} from '@/constants.js';

const matchImgRegex = /(.*?)\.(jpg|jpeg|png|gif|bmp|heic)$/i;

const axiosAdmin2 = instBundle.axiosAdmin2;

const actions = {
	async getDetails(_, idEvent) {
		try {
			const {
				data: { data },
			} = await axiosAdmin2.get(`/api/events/${idEvent}`);
			return {
				...data,
				eventApplyData: data.eventQuestionList
					.filter(type => type.applyType !== 4)
					.map(({ idEventQuestion, applyType }) => ({
						idEventQuestion,
						applyType,
					}))
					.sort((a, b) => b.idEventQuestion - a.idEventQuestion),
			};
		} catch (err) {
			console.error(err);
			alert('이벤트상세데이터를 불러오는데 실패했습니다.');
		}
	},
	async getAttendeeList(_, params) {
		try {
			const qs = Object.keys(params).reduce((acc, key, idx) => {
				const v = params[key];
				acc += idx === 0 ? '?' : '&';
				acc += `${key}=${v}`;
				return acc;
			}, '');

			const { data, config } = await axiosAdmin2.get(
				`/api/event/candidate/list${qs}`
			);

			const attendeeList = data.eventCandidateItemSearchList.map(
				item => ({
					...item,
					eventQuestionType:
						item.eventQuestionAnswer &&
						item.eventQuestionAnswer.match(matchImgRegex)
							? 'file'
							: 'answer',
					blind: item.blind ? 'Blind' : '',
					black: item.grade === -3 ? 'Black' : '',
					eventCandidate: item.eventCandidate
						? item.eventCandidate
								.substring(0, 16)
								.split(' ')
								.join('<br>')
						: '',
					age: item.age || '',
					gender:
						item.gender === 8
							? ''
							: genderList.find(
									genderItem =>
										Number(genderItem.id) === item.gender
								)?.value || '',
					skinType:
						item.skinType === 13
							? ''
							: skinTypeList.find(
									skinTypeItem =>
										Number(skinTypeItem.id) ===
										item.skinType
								)?.value || '',
					createDate: item.createDate
						? moment(item.createDate, 'YYYYMMDD').format(
								'YYYY-MM-DD'
							)
						: '',
					otherEventInfo: item.eventCandidateHistoryEvents
						? (e => {
								const otherEventIdArr = e.split(',');
								const eventId = Math.max(...otherEventIdArr);
								const cnt = otherEventIdArr.length - 1;

								return {
									eventId,
									subStr: cnt ? ` 외 ${cnt}건` : '',
									link: `/events/${eventId}/winner-pick`,
								};
							})(item.eventCandidateHistoryEvents)
						: null,
					beautyProfile: beautyProfileTitleFromIdList(
						(item.beautyProfileIdList || '').split(',')
					),
					instaCate:
						item.isExternalAdvertising &&
						item.externalAdvertising?.instagramCategory
							? instaCateList.find(
									instaCate =>
										instaCate.id ===
										item.externalAdvertising
											.instagramCategory
								).txt
							: '',
					gradeTitle:
						gradeList.find(
							gradeItem => Number(gradeItem.id) === item.grade
						)?.name || '',
					recentEventHistory: (eventHistory => {
						if (!eventHistory) return '';

						const lastEventInfoArr = eventHistory.split(',');
						const eventType = lastEventInfoArr.shift();
						const dateString = lastEventInfoArr.pop();
						const brandInfo = lastEventInfoArr.join(',');
						const targetDate = new Date(dateString);
						const targetYear = targetDate.getFullYear();
						const targetMonth = targetDate.getMonth();
						const now = new Date();
						const nowYear = now.getFullYear();
						const nowMonth = now.getMonth();

						if (targetDate.getTime() >= now.getTime()) {
							return '';
						} else {
							const eventTypeTitle =
								eventTypeList.find(
									item => item.id === eventType
								)?.value || '';
							const month =
								(nowYear - targetYear) * 12 +
								(nowMonth - targetMonth);
							const dateInfo = `${month.toString().padStart(2, '0')}개월전(${targetYear}-${(targetMonth + 1).toString().padStart(2, '0')})`;
							return `${eventTypeTitle} / ${brandInfo} / ${dateInfo}`;
						}
					})(item.recentEventHistory),
				})
			);
			return {
				totalAttendeeCnt: data.eventCandidateTotalCount,
				searchAttendeeCnt: data.eventCandidateItemSearchCount,
				attendeeList,
				lastAttendeeListReqUrl: config.url,
			};
		} catch (err) {
			console.error(err);
			if (err && err.response && err.response.status === 404) {
				alert(err.response.data.message);
			}
		}
	},
	async getWinnerDetails(_, idEvent) {
		try {
			const { data, config } = await axiosAdmin2.get(
				`/api/event/candidate/${idEvent}`
			);
			const list = data.eventCandidateHistoryList;
			const winnerMappedPdtList =
				list && list.length
					? list.map(item => ({
							...item,
							candidates: Array.isArray(item.candidates)
								? item.candidates.map(winner => ({
										...winner,
										originWinner: winner.status === 2,
										age: winner.age || '',
										gender:
											winner.gender === 8
												? ''
												: genderList.find(
														genderItem =>
															Number(
																genderItem.id
															) === winner.gender
													).value,
										skinType:
											winner.skinType === 13
												? ''
												: skinTypeList.find(
														skinTypeItem =>
															Number(
																skinTypeItem.id
															) ===
															winner.skinType
													).value,
										fullAddr: `${winner.userZipcode ? `(${winner.userZipcode}) ` : ''}${winner.userAddress || ''}${winner.userAddressMore ? ` ${winner.userAddressMore}` : ''}`,
										beautyProfile:
											beautyProfileTitleFromIdList(
												(
													winner.beautyProfileIdList ||
													''
												).split(',')
											),
										instaCate:
											winner.isExternalAdvertising &&
											winner.externalAdvertising
												?.instagramCategory
												? instaCateList.find(
														instaCate =>
															instaCate.id ===
															winner
																.externalAdvertising
																.instagramCategory
													).txt
												: '',
										gradeTitle: gradeList.find(
											gradeItem =>
												Number(gradeItem.id) ===
												winner.grade
										).name,
										hasReview: winner.reviewProductCnt > 0,
									}))
								: [],
						}))
					: [{ idProduct: null, candidates: [], candidateCnt: 0 }];

			return {
				surveyLink: data.surveyLink, // 설문지 링크
				isSelectComplete: data.changeEventCadidateFlag, // 당첨자 선정 완료된 이벤트인지 여부
				totalWinnerCnt: data.eventCandidateHistoryTotal || 0, // 당첨자 수
				winnerMappedPdtList, // 당첨자리스트 매핑된 제품리스트
				tabbedPdtId: winnerMappedPdtList[0].idProduct,
				originWinnerMappedPdtList: cloneDeep(winnerMappedPdtList),
				winnerDesc: data.winnerDescription,
				lastWinnerDetailsReqUrl: config.url,
			};
		} catch (err) {
			console.error(err);
		}
	},
	async winnerComplete(_, params) {
		try {
			await axiosAdmin2.post(
				'/api/event/candidate/history/complete',
				params
			);
			window.location.reload();
		} catch (err) {
			console.error(err);
			alert('당첨자 저장에 실패했습니다.');
		}
	},
	async winnerTempSave(_, params) {
		try {
			await axiosAdmin2.post('/api/event/candidate/history', params);
			window.location.reload();
		} catch (err) {
			console.error(err);
			alert('당첨자 임시저장에 실패했습니다.');
		}
	},
};

export default {
	namespaced: true,
	actions,
};
